import { createSlice } from '@reduxjs/toolkit';

export const profilesSlice = createSlice({
    name: 'profiles',
    initialState: {
        CaseManagementQuestionnaire:{},
        Education:{},
        housingData:{},
        Transportation:{},
        Insurance:{},
        FinancialResources:{},
        Dental:{},
        Adl: {},
        Spirituality:{},
        MentalHealth:{},
        DomesticViolence:{},
        Service:{},
        summaryData:{}
    },
    reducers: {
        updateSection: (state, { payload }) => {
            const { section, data } = payload;
            if (state[section] !== undefined) {
                state[section] = { ...data[section] };
            }
        },

        updateSectionMentalHealth: (state, { payload }) => {
            const { section, data } = payload;
            if (state[section] !== undefined) {
                state[section] = { ...state[section], ...data[section] };
            }
        },

        // ✅ Método para resetear una sección específica
        resetSection: (state, { payload }) => {
            if (state[payload] !== undefined) {
                state[payload] = {};
            }
        },

        // ✅ Método para resetear TODO el estado
        resetAll: (state) => {
            Object.keys(state).forEach((key) => {
                if (key !== 'status' && key !== 'email' && key !== 'displayName') {
                    state[key] = {};
                }
            });
        }
    }
});

export const {
    updateSection,
    resetSection,
    resetAll,
    updateSectionMentalHealth
} = profilesSlice.actions;